<template>
    <el-dialog v-model="dialogShow" title="学习设置" width="1000px" align-center :before-close="handleClose"
        destroy-on-close>
        <div class="inrect">
            <!--leftPanel-->
            <div class="leftPanel">
                <div @click="selectNavKey=item.key" class="navitem" :class="{'navsel':selectNavKey==item.key}" v-for="item in listNavMenu" :key="item.key">
                    <i class="fa" :class="item.icon"></i>
                    <span class="mgl10">{{ item.name }}</span>
                </div>
            </div>
            <!--rightPanel-->
            <el-scrollbar class="rightPanel">
                <component :is="selectNavKey"></component>
            </el-scrollbar>
        </div>
    </el-dialog>
</template>

<script>
import SpellBasicConfig from '../config/SpellBasicConfig.vue';
import SoundEffectConfig from '../config/SoundEffectConfig.vue';
import SpellFontSizeConfig from '../config/SpellFontSizeConfig.vue';

export default {
    name: 'SpellSettingDialog',
    components: {
        SpellBasicConfig,
        SoundEffectConfig,
        SpellFontSizeConfig
    },
    props: {
        showDialog: Boolean,
    },
    watch: {
        showDialog: function (nval, old) {
            this.dialogShow = nval
        }
    },
    data() {
        return {
            dialogShow: this.showDialog,
            selectNavKey:"SpellBasicConfig",
            listNavMenu: [
                { name: "常规设置", key: "SpellBasicConfig", icon:"fa-cog" },
                { name: "音效设置", key: "SoundEffectConfig", icon:"fa-volume-up" },
                { name: "字体设置", key: "SpellFontSizeConfig", icon:"fa-font" },
            ]

        }
    },
    mounted: function () {

    },
    methods: {

        ///关闭窗口
        handleClose: function (done) {
            this.$emit('closeDialog')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navitem{
    
    display: flex;
    align-items: center;
    height: 40px;
    margin-right: 10px;
    color: var(--ek-text-color2);
    padding-left: 15px;
    border-radius: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.navitem:not(.navsel):hover {
    background: var(--ek-card-color2);
}

.navsel{
    background: var(--ek-color-primary);
    color: white!important;
}
.inrect {
    height: 700px;
    display: flex;
}

.leftPanel {
    border-right: 1px solid var(--ek-split-lineColor);
    width: 150px;
}
.rightPanel{
    width: 0px;
    flex-grow: 1;
    padding-left: 20px;
}
</style>